module.exports = __webpack_public_path__ + "static/img/finishes-bg.0de878d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/finishes-bg.jpg
// module id = P9sU
// module chunks = 1